import api from '../api';
import {
  ReservationResponse,
  ReservationModel,
  CanReserveResponse,
  ReserveFeedbackModel,
} from '../models/reservation';

const baseUrl = 'pwa/reservation';
export class ReservationService {
  public getReservations = () =>
    api.get<ReservationResponse[]>('/pwa/reservation');

  public show = (reservation_id: number) =>
    api.get<ReservationResponse>(`${baseUrl}/find/${reservation_id}`);

  public canReserve = () =>
    api.get<CanReserveResponse>(`${baseUrl}/can-reserve`);

  public create = (data: ReservationModel) => api.post(`${baseUrl}`, data);

  public checkIn = (reservation_id: number, desk_code: string) =>
    api.post(`${baseUrl}/check-in`, {
      reservationId: reservation_id,
      token: desk_code,
    });

  public checkOut = (reservation_id: number) =>
    api.post(`${baseUrl}/check-out`, { reservationId: reservation_id });

  public cancelReservation = (reservation_id: number) =>
    api.post(`${baseUrl}/cancel`, { reservationId: reservation_id });

  public feedback = (data: ReserveFeedbackModel) =>
    api.post(`${baseUrl}/feedback`, data);

  public finisheds = () => api.get<ReservationResponse[]>(`${baseUrl}/finisheds`);
}

const reservationService = new ReservationService();
export default reservationService;
